module.exports = __webpack_public_path__ + "img/icono.f7e91547.png";